// import pixiSound from "pixi-sound";
// import config from "../framework/dev/tsconfig";
// import { reels_lenghts, states } from "../framework/src/engine/madnes/madnes_variables";
import { getRandomInt, intFormat } from "../framework/src/helpers";
import { STATES } from "../framework/src/states/states";
import { CONFIG_PARAMS } from "../framework/src/system/SystemConfig";
// import Commander from "./Commander";

export default class States {

    constructor(commander) {
        this.commander = commander;
    }

    move(reel, shift) { }

    accUp(data) {        
        if (!this.audio.isPlaying("reel_Start_1") && !this.audio.isPlaying("reel_Start_2") && !this.audio.isPlaying("reel_Start_3")) {
            this.audio.playTrack("reel_Start_" + getRandomInt(1, 3));
        }
    }

    accDown(data) {
        
        let reel = data.reel;
        // console.log("acc down", reel._spinSymbols);
        for (let symbol of reel._spinSymbols) {
            symbol.alpha = 1;
        }
    }

    spin(data) {
        
        let reel = data.reel;

        this.reelsData.push(data);
        reel._symbols[0].visible = true ;
        // reel._symbols[reel._symbols.length-1].visible = true;

        for (let symbol of reel.getResSymbols()) {
            symbol.blur();
            symbol.alpha = 1;
        }
        
        // console.log("spin ", reel.getSpinSymbols());
        for (let symbol of reel.getSpinSymbols()) {
            symbol.blur();
            symbol.alpha = 1;
        }
    }
   
    stopping(data) {
        // this.specifics in the commander , used in most states        
        this.specifics = this.config.get(CONFIG_PARAMS.GAME_SPECIFICS); 

        if (!this.GameFreespins.isInFreeSpins() && this.specifics != undefined) {
            let searchingIndex;
            try {
                searchingIndex = this.specifics.searching;
            } catch (err) {
                console.error(" SEARCH INDEX IS EMPTY ", err);
            }

            let reelId = data["reel"]["id"];

            /**
             *  all reel delays have to be run at start (at reel id 0) ,
             *  because the reels are not calling method stopping in the propper order 
             *  and also reels delay can be only called on reel that isn't in stopped event ,
             *  meaning need to be 1 reel ahead
             */
            if (reelId === 0) {
                let tempReelsLength = this.config.get(CONFIG_PARAMS.REELS).length;

                for (let i = 0; i < tempReelsLength; i++) {
                    let delay = this.reelDelay["searchIndex" + searchingIndex][i];
                    this.slots.reels.setSymbolsToStoppingDelay(i, delay);                    
                }
            }

            if (searchingIndex > 0) {

                if (reelId === 3 || reelId === 2) {
                    this.IdleAnimation.stopSearchingAnimation();
                }

                if (searchingIndex === 1) {                     
                    if (!this.audio.isPlaying("reel_Search_Short")) {
                        this.audio.playTrack("reel_Search_Short");
                    }
                }

                // storm searching animation animates on the next reel  
                if (reelId === 1 && !data.forceStopping) {    
                    this.IdleAnimation.runSearchingAnimation(this.ropesPos[reelId], this.ropesPos[reelId + 1], 40);  // storm animation goes here                    
                }

                if (searchingIndex === 2) {
                    if (!this.audio.isPlaying("reel_Search_Long")) {
                        this.audio.playTrack("reel_Search_Long");
                    }

                    // storm searching animation goes animates on the next reel , reel id 1 it goes to 2
                    if ((reelId === 2) && !data.forceStopping) {
                        this.IdleAnimation.runSearchingAnimation(this.ropesPos[reelId], this.ropesPos[reelId + 1], 40);  // storm animation goes here
                    }
                }
            }

            if (reelId === 2) {
                this.states.setState(STATES.FORCESPIN);
            }
        }
    }

    brakeDown(data) {

        let reel = data.reel;

        for (let symbol of reel.getResSymbols()) {
            symbol.unblur();            
        }
        for (let symbol of reel.getSpinSymbols()) {
            symbol.unblur();
            symbol.alpha = 0;
        }

        if (this.specifics != undefined) {
            //let specifics = this.config.get(CONFIG_PARAMS.GAME_SPECIFICS);            

            if (this.specifics["searching"] > 0 && ((data["reel"]["id"] === 1) || (data["reel"]["id"] === 2) || (data["reel"]["id"] === 3))) {                

                let scatterSpeed = this.config.get(CONFIG_PARAMS.BEHAVIOR)["reel"]["spin"]["scatterSpeed"];
                let nextReel = reel.getId() + 1;
                this.reelsData[nextReel]["spinner"].speedTo(scatterSpeed);
                this.states.setState(STATES.SPIN);
            }

            if (data.reel.id === 3 && !this.GameFreespins.isInFreeSpins()) {                
                this.states.setState(STATES.FORCESPIN);
            }

            if (data.reel.id === 4) {
                this.scatterCount = 1;
            }

            if (this.hazScatter(data.reel)) {
             
                if (!data.forceStopping) {
                    this.audio.playTrack("symbol_Ship_" + this.scatterCount); 
                } else if (this.scatterCount === 1) { 
                    // this have to be dependant on scattercount since every track is different (symbol_Ship_1, symbol_Ship_2, symbol_Ship_3)
                    this.audio.playTrack("symbol_Ship_" + this.scatterCount);
                }
                this.scatterCount++;
            }
            
            if (!data.forceStopping) {
                this.audio.playTrack("reel_Stop"); 
            } else if (!this.audio.isPlaying("reel_Stop")) {
                this.audio.playTrack("reel_Stop");
            }
        }
    }

    brakeUp(data) {
        let reelId = data["reel"]["id"];
        // let specifics = this.config.get(CONFIG_PARAMS.GAME_SPECIFICS);

        if (reelId === 3 && (this.specifics != undefined && this.specifics.searching < 2 ) && (this.game.addResult !== undefined || this.game.AddResult !== null)) {//&& this.game.addResult.lineWins !== undefined)) {
            this.states.setState(STATES.FORCESPIN);
        }
    }

    stop(data) {
        // this.IdleAnimation.stopSearchingAnimation();
    }
}
